import { cn } from '../../lib/utils'
import { CountryFlag } from './CountryFlag'

export interface MarketLabelProps {
  /** The market as the reader sees it, already localized ("Mexico", "Global"). */
  label: string
  /** ISO alpha-2 or subdivision code; missing ("Global", a region) draws a globe. */
  code?: string | null
  className?: string
  flagClassName?: string
  'data-testid'?: string
}

/** A flag (or a globe) and the market's name, on one line that truncates. */
export function MarketLabel(props: MarketLabelProps) {
  const { label, code, className, flagClassName, 'data-testid': testId } = props

  return (
    <span
      className={cn('inline-flex min-w-0 items-center gap-1.5', className)}
      data-testid={testId}
    >
      <CountryFlag code={code} className={flagClassName} />
      <span className="truncate">{label}</span>
    </span>
  )
}
